import { Modal } from "react-bootstrap";
import "./NotificacionModal.css"; // Archivo CSS separado

export const ModalNotificaciones = ({ notifications, show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered contentClassName="notificacion-modal-content">
      <div className="custom-modal">
        {/* Título del modal */}
        <div className="modal-header">
          <h5 className="modal-title">Notificaciones</h5>
          <button type="button" className="close" onClick={handleClose}>
            &times;
          </button>
        </div>

        {/* Lista de Notificaciones */}
        <div className="modal-body">
          {notifications.length > 0 ? (
            <div className="notifications-list">
              {notifications.map((notif, index) => (
                <div key={index} className="notification-item">
                  <p className="notification-title">{notif.title}</p>
                  <p className="notification-description">{notif.description}</p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-muted">No hay notificaciones</p>
          )}
        </div>
      </div>
    </Modal>
  );
};